<template>
  <div class="project-item" @click="openProjectDetails(data)">
    <div class="top-img">
      <el-image :src="data.imgUrl ? data.imgUrl:require(`@/assets/demo.png`)" fit="cover"> </el-image>
      <div class="status text" :class="data.tranferType==3?'ys':'jp'">{{data.transferTypeDesc}}</div>
      <div class="flag" v-if="data.statusDesc == '已成交'">
        <img :src="require(`@/assets/icon/stauts_icon/6.png`)" />
        <span>已成交</span>
      </div>
    </div>
    <div class="title"><span v-if="($store.state.cityArea.areaConfigName == $store.state.cityArea.city || $store.state.cityArea.areaConfigName == '全部') && data.location" style="color: rgb(95,144,70);padding-right: 5px;">{{`[${data.location.split('/')[2]}]`}}</span>{{data.name}}</div>
    <div class="info">
      <div class="left">
        <span>{{data.tranferType == 1 ? '起拍价格：' : '标的价格：'}}</span>
        <span v-if="data.tranferType == 4">价格面议</span>
        <span v-else-if="data.businessType == 1 || data.businessType == 2">{{data.bidType == 1 ? `${data.listingPrice}元/${data.holdAreaUnit || '亩'}` : `${data.listingPrice}元/${data.holdArea}${data.holdAreaUnit || '亩'}`}}</span>
        <span v-else>{{data.bidType == 1 ? `${data.listingPrice}元/${data.unit}` : `${data.listingPrice}元/${data.number}${data.unit}`}}</span>
      </div>
      <div class="right" v-if="data.statusDesc != '已成交'">{{data.statusDesc}}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: Object,
    index: String | Number,
  },
  filters: {
    statusTransform(key) {
      // 0 审核中 1 审核通过 2 审核不通过 3 未成交 4 部分成交 5 签约中 6 已成交
      if (!key) return "";
      let status = [
        "审核中",
        "审核通过",
        "审核不通过",
        "未成交",
        "部分成交",
        "签约中",
        "已成交"
      ];
      return status[key];
    }
  },
  methods: {
    openProjectDetails(data) {
      // if (!this.$store.state.userInfo.personVertification) {
      //   return this.$store.state.vertification = true
      // }
      this.$router.push({
        name: 'PropertyProjectDetails',
        query: { id: data.id ,status:data.status,type:data.businessType,index:this.index}
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.project-item {
  cursor: pointer;
  width: 275px;
  // width: calc(25% - 14px);
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
  overflow: hidden;
  box-sizing: border-box;
  margin: 0 15px 10px;
  .top-img {
    width: 100%;
    height: 218px;
    position: relative;
    .el-image {
      width: 100%;
      height: 218px;
      overflow: hidden;
      border-radius: 7px 7px 0 0;
      /deep/ .image-slot {
        background-color: #f5f7fa;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .status {
      position: absolute;
      width: 64px;
      height: 23px;
      top: 0;
      right: 0;
      text-align: center;
      border-radius: 0 6px;
      &.jp {
        background-image: url(../../../assets/jingpai.png);
        background-position: 0 0;
        background-size: 100% 100%;
      }
      &.ys {
        background-image: url(../../../assets/yushou.png);
        background-position: 0 0;
        background-size: 100% 100%;
      }
      &.text {
        color: #fff;
        line-height: 23px;
      }
    }
    .flag{
      width: 100%;
      height: 36px;
      line-height: 36px;
      background: rgba(0,0,0,0.50);
      text-align:center;
      font-size:14px;
      color: #fff;
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 20px;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .title {
    font-size: 14px;
    color: rgba(57, 66, 89, 1);
    margin: 10px 0;
    padding: 0 10px;
    line-height: 15px;
  }
  .info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 10px 20px;
    .left {
      font-size: 12px;
      font-weight: 400;
      color: rgba(96, 105, 126, 1);
      display: flex;
      align-items: center;
      span {
        font-size: 12px;
        &:nth-of-type(1) {
          white-space: nowrap;
          color: rgba(96, 105, 126, 1);
        }
        &:nth-of-type(2) {
          color: rgba(243, 92, 76, 1);
          font-size: 18px;
          font-weight: 600;
        }
      }
    }
    .right {
      font-size: 12px;
      color: rgba(243, 92, 76, 1);
      white-space: nowrap;
    }
  }
  .pageviews {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(168, 170, 174, 1);
  }
}
.project-item:nth-of-type(4n){
  margin-right: 0 !important;
}
.project-item:nth-of-type(4n + 1){
  margin-left: 0 !important;
}
</style>